/**
 * SOLID Review
 * S — Strong. One concern: leave a User Timing measure around one synchronous step, and never fail it.
 * O — Strong. Any step; nothing here names one.
 * L — N/A — a function.
 * I — Strong. One function over a two-method slice of `Performance`.
 * D — Strong. The slice is a parameter; the composition root hands it the browser's `performance`.
 */

/** The two Level-2 User Timing calls this needs — older than any browser the app supports. */
export interface IServiceUserTiming {
  mark(name: string): unknown;
  measure(name: string, startMark: string): unknown;
}

/**
 * Run `step` and leave a `name` measure around it (frontend strict-ports plan, FE1 stop rule): the
 * client trace reads `ml3d:assemble` back to attribute what assembling the graph costs at load.
 *
 * A diagnostic must never cost the screen. This runs at module load, before React has anything to
 * show, so a browser without User Timing, or one that refuses the call, runs the step unmeasured
 * rather than white-screening.
 */
export function timed<T>(timing: IServiceUserTiming, name: string, step: () => T): T {
  const start = `${name}:start`;
  try { timing.mark(start); } catch { /* unmeasured */ }
  const result = step();
  try { timing.measure(name, start); } catch { /* unmeasured */ }
  return result;
}
